export default [
  {
    id: 'age-group',
    name: 'Age Group',
  },
  {
    id: 'team-name',
    name: 'Team Name',
  },
  {
    id: 'section-name',
    name: 'Section Name',
  },
];
